// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--2u1K-","faqTitle":"faq-module--faqTitle--TyAwg","faqTitleActive":"faq-module--faqTitleActive--1Mulw","faqAnswer":"faq-module--faqAnswer--MZqDe"};